import {
  Box,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { useCollectionViewContext } from './CollectionViewPageContext'
import { useDiRef } from '@/common/react/di-hooks'
import type { CollectionViewsService } from '@/objects/services/CollectionViewsService'
import { groupableTypes } from '@/objects/services/CollectionObjectsService.ts'
import { globalCssVars } from '@/core/theme/GlobalCssVars.ts'

export function GroupByPopover() {
  const { viewSettings, objectType, collectionId } = useCollectionViewContext()
  const collectionViewsService = useDiRef<CollectionViewsService>('CollectionViewsService')

  const groupableProps =
    objectType?.propertyDefinitions.filter((p) => groupableTypes.has(p.type)) ?? []
  const currentValue = viewSettings?.groupByColumnId ?? null

  function setGroupBy(propDefId: number | null) {
    collectionViewsService.updateViewSettings(collectionId, {
      groupByColumnId: propDefId,
    })
  }

  return (
    <Box sx={{ p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, minWidth: 220 }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, px: 0.5 }}>
        Group by
      </Typography>

      {currentValue == null ? (
        <List dense disablePadding>
          {groupableProps.map((p) => (
            <ListItemButton
              key={p.id}
              onClick={() => setGroupBy(p.id)}
              sx={{ borderRadius: globalCssVars.radius3 }}
            >
              <ListItemText primary={p.name} />
            </ListItemButton>
          ))}
          {groupableProps.length === 0 && (
            <Typography variant="body2" color="text.secondary" sx={{ px: 1 }}>
              No groupable properties
            </Typography>
          )}
        </List>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Select
            size="small"
            value={currentValue}
            onChange={(e) => setGroupBy(Number(e.target.value))}
            sx={{ flex: 1 }}
          >
            {groupableProps.map((p) => (
              <MenuItem key={p.id} value={p.id}>
                {p.name}
              </MenuItem>
            ))}
          </Select>

          <IconButton size="small" onClick={() => setGroupBy(null)}>
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  )
}
